import LoginPage from './LoginPage'
import {fullPageLayoutConfig} from '../layout.helper'

export const LoginPageConfig = {
  settings: {
    layout: fullPageLayoutConfig,
  },
  routes: [
    {
      path: '/login',
      component: LoginPage,
    },
  ],
}



// WEBPACK FOOTER //
// ./src/main/content/login/LoginPageConfig.js